import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
/*
  Generated class for the TimeoutFunctionsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TimeoutFunctionsProvider {
  constructor(public http: HttpClient) {

  }

  doLogoutFunctions(page){
    if (page && page.viewCtrl) page.viewCtrl.dismiss().catch(err =>{})
    // page.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/providers/timeout-functions/timeout-functions.ts